module.exports = __webpack_public_path__ + "static/media/dc10b3bd-5076-4df5-a5f5-e5961f4a6938.e17abc84.woff";